
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mainStore, bucketStore } from '../../../utils/store-accessor';
import UploadFilesComponent from '@/components/UploadFilesComponent.vue';
import LogShowComponent from '@/components/LogShowComponent.vue';

@Component({
  components: {
    UploadFilesComponent,
    LogShowComponent,
  },
})
export default class Show extends Vue {
  @Prop({ default: false }) readonly allowEdit;

  public dialog = false;

  public colors = ['primary', 'secondary', 'yellow darken-2', 'red', 'orange'];

  public lastSixParcerias: any = [];

  public item: any = {};

  public images: any[] = [];

  public arquivos = [];

  public isLoading = true;

  public nameBucket = 'parceria';

  get files() {
    if (new Date(this.item['created_at'].substr(0, 10)) >= new Date('2022-02-22')) {
      return bucketStore.files;
    } else {
      return bucketStore.files.filter((f) => f['blob']['id'] == this.item['id']);
    }
  }

  get userProfile() {
    return mainStore.userProfile;
  }

  public openSite({ site }) {
    const a = document.createElement('a');
    a.href = site;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  public async doDownload() {
    this.arquivos.forEach((image) => {
      //@ts-ignore
      const url = image.download_url;
      //@ts-ignore
      const filename = image.blob.full_name;

      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const blobURL = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobURL;
          a.style.display = 'none';

          if (filename && filename.length) a.download = filename;
          document.body.appendChild(a);
          a.click();
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  public openParceria(parceria) {
    this.dialog = false;
    this.$emit('switchParceria', parceria);
  }

  public async openContrato(url: string) {
    let a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.download = 'contrato';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  public async show(params, lastSixParcerias) {
    this.isLoading = true;
    this.item = params;
    this.lastSixParcerias = lastSixParcerias;

    // A partir da data abaixo, foi melhorada a bucketStore, mas só funciona com novos arquivos
    if (new Date(this.item['created_at'].substr(0, 10)) >= new Date('2022-02-22')) {
      await bucketStore.getFilesByID({
        bucket_name: 'parceria',
        file_id: String(this.item['id']),
      });
    } else {
      await bucketStore.getFilesByBucketName('parceria');
    }

    this.files.forEach((file) => {
      switch (true) {
        case file['blob']['name'].indexOf('jpg') > -1 ||
          file['blob']['name'].indexOf('jpeg') > -1 ||
          file['blob']['name'].indexOf('png') > -1:
          this.item.preview = file['download_url'];
          break;
        case file['blob']['full_name'].toLowerCase().indexOf('contrato') > -1:
          this.item.contratoSrc = file['download_url'];
          break;
        case file['blob']['full_name'].toLowerCase().indexOf('materialapoio') > -1:
          this.item.materialApoioSrc = file['download_url'];
          break;
      }
    });

    this.isLoading = false;
    this.dialog = true;
  }
}
